<section class="cancel-job-success" role="status" aria-live="polite">
  <mat-icon
    class="cancel-job-success__icon"
    aria-hidden="true"
    data-testid="cancel-job-success-icon"
    >check_circle</mat-icon
  >
  <p class="cancel-job-success__headline">Success!</p>
  <p class="cancel-job-success__message">The translation job has been cancelled.</p>
</section>
